document.addEventListener("DOMContentLoaded", function () {
  imageSwatches();
});


function imageSwatches(params) {
    var productGrids = document.querySelectorAll(".grid.product-grid");

  productGrids.forEach(function (productGrid) {
    var sectionId = productGrid.getAttribute("data-section-id");
    var variantDataMap =
      window["variantDataMap" + sectionId.replace(/-/g, "_")];

    console.log("variantDataMap"+variantDataMap);

    productGrid.addEventListener("change", function (e) {
      if (
        e.target.matches(
          'input[type="radio"][data-section-id="' + sectionId + '"]'
        )
      ) {
        var card = e.target.closest(
          `.card-product-custom-div[data-section-id="${sectionId}"]`
        );
        var variantId = e.target.getAttribute("data-variant-id");
        var variantData = variantDataMap[variantId];
        var attr_variant_image = e.target.getAttribute('data-image-url');
          var productImageElement = card.querySelector(".card__media img");
        console.log("varaint data"+e.target.getAttribute('data-image-url'));



        // Update the product image with lazy loading logic
      
        if (productImageElement) {
          var lazyLoadAllVariants =
            card.getAttribute("data-lazy-load-all-variants") === "true";
          if (attr_variant_image) {
           
                        var dynamicSrcset = [
             attr_variant_image + "?width=165 165w",
            attr_variant_image + "?width=360 360w",
             attr_variant_image + "?width=533 533w",
              attr_variant_image + "?width=720 720w",
             attr_variant_image + "?width=940 940w",
             attr_variant_image + "?width=1066 1066w",
            ].join(", ");

                productImageElement.srcset = dynamicSrcset;
            productImageElement.src = attr_variant_image;
          }else{

                    if (!variantData) {
          console.log("No data found for variant:", variantId);
          return;
        }
            
            if (lazyLoadAllVariants) {
            var preloadedImage = card.querySelector(
              `img[data-variant-id="${variantId}"]`
            );
            if (preloadedImage) {
              productImageElement.src = preloadedImage.src;
              productImageElement.srcset = preloadedImage.srcset;
            } else {
              console.log(
                "Matching preloaded image not found for variant:",
                variantId
              );
            }
          } else {
            // Update src and srcset for responsive images
            var dynamicSrcset = [
              variantData.imageUrl + "?width=165 165w",
              variantData.imageUrl + "?width=360 360w",
              variantData.imageUrl + "?width=533 533w",
              variantData.imageUrl + "?width=720 720w",
              variantData.imageUrl + "?width=940 940w",
              variantData.imageUrl + "?width=1066 1066w",
            ].join(", ");
            productImageElement.srcset = dynamicSrcset;
            productImageElement.src = variantData.imageUrl;
          }
          }
        } else {
          console.log("No product image element found in this card.");
        }

        // Update the product URL
        // var productLinks = card.querySelectorAll(
        //   'a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]'
        // );
        // productLinks.forEach(function (link) {
        //   link.href = variantData.productUrl;
        // });
      } else {
        console.log("Change detected, but not on a swatch.");
      }
    });
  });
}


document.addEventListener("DOMContentLoaded", function () {
   updateSwatchName();
});

function updateSwatchName() {
   document.querySelectorAll(".collection-product-card__variants_main").forEach(function (card) {
        let firstSwatch = card.querySelector(".collection-product-card__swatch input[type='radio']:checked") || 
                          card.querySelector(".collection-product-card__swatch input[type='radio']");

        if (firstSwatch) {
            updateColorName(card, firstSwatch);
        }

        card.querySelectorAll(".collection-product-card__swatch input[type='radio']").forEach(function (input) {
            input.addEventListener("change", function () {
                updateColorName(card, this);
            });
        });
    });
}

function updateColorName(card, input) {
    let colorNameElement = card.querySelector(".product-card__variants_main_clrname");
    let label = input.nextElementSibling; // Get the corresponding <label> tag
    let newColor = label ? label.getAttribute("data-color") : null;

    if (colorNameElement && newColor) {
        colorNameElement.textContent = newColor;
    }
}


















 var interval = setInterval(function () {
    // Check if product-recommendations .product-grid is available
    var productRecommendations = document.querySelector('product-recommendations .product-grid');

    if (productRecommendations) {
     imageSwatches();
      updateSwatchName();

      // Stop checking once the product recommendations are found
      clearInterval(interval);

      // Now, run your logic related to product recommendations

    } else {
      console.log("No product recommendations grid found!");
    }

  }, 1000); 

